import { createFileRoute } from '@tanstack/react-router';
import { PricingPage } from '../screens/pricing/PricingPage';

/** Public: the packages (docs/pricing.md). */
export const Route = createFileRoute('/pricing')({
  component: PricingPage,
});
